import { transparentize } from 'polished';
import { CardSettings } from './types';

export const cardSettings: CardSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        small: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'gray.extraLight',
          boxShadow: (props: Record<string, any>) =>
            `0 12px 24px ${transparentize(0.85, props.colors.black.dark)}`,
        },
        regular: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'gray.extraLight',
          boxShadow: (props: Record<string, any>) =>
            `0 8px 16px ${transparentize(0.85, props.colors.black.dark)}`,
        },
      },
    },
    headerVariant: {
      prop: 'headerVariant',
      variants: {
        regular: {
          paddingTop: [3, 5],
          paddingRight: [5, 6],
          paddingBottom: [3, 5],
          paddingLeft: [5, 6],
          borderBottomStyle: 'solid',
          borderBottomWidth: '1px',
          borderBottomColor: 'gray.light',
        },
        small: {
          padding: 4,
          borderBottomStyle: 'solid',
          borderBottomWidth: '1px',
          borderBottomColor: 'gray.light',
        },
      },
    },
    bodyVariant: {
      prop: 'bodyVariant',
      variants: {
        regular: {
          paddingTop: [5, 6],
          paddingRight: [5, 6],
          paddingBottom: [5, 6],
          paddingLeft: [5, 6],
        },
        small: {
          paddingTop: 3,
          paddingBottom: 3,
          paddingLeft: 4,
          paddingRight: 4,
        },
      },
    },
    footerVariant: {
      prop: 'footerVariant',
      variants: {
        regular: {
          paddingTop: [3, 5],
          paddingRight: [5, 6],
          paddingBottom: [3, 5],
          paddingLeft: [5, 6],
          borderTopStyle: 'solid',
          borderTopWidth: '1px',
          borderTopColor: 'gray.light',
        },
        small: {
          paddingTop: 3,
          paddingBottom: 3,
          paddingLeft: 4,
          paddingRight: 4,
          borderTopStyle: 'solid',
          borderTopWidth: '1px',
          borderTopColor: 'gray.light',
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        white: {
          backgroundColor: 'white.main',
        },
        gray: {
          backgroundColor: 'white.dark',
        },
      },
    },
    border: {
      prop: 'border',
      variants: {
        rounded: {
          borderRadius: 3,
        },
        sharp: {
          borderRadius: 0,
        },
      },
    },
  },
};
